import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TenantSubscriptionModel } from '../../../../../models/aggregates/tenant-subscription';
import { BaseApiTemplateService, Core2Config } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionBackofficeEPService extends BaseApiTemplateService<TenantSubscriptionModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenant-subscriptions/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenant-subscriptions/backoffice-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenant-subscriptions/backoffice-ep';
    this.httpClient = http;
  }
}

